import { NgModule } from '@angular/core';
import { NkNavbarComponent } from './navbar.component';

@NgModule({
  imports: [
   NkNavbarComponent
  ],
  exports: [NkNavbarComponent],
})
export class NkNavbarModule {}
